import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': "*",
    'Accept-Language': localStorage.getItem('lang') || 'ru'
  }
});

export default axiosInstance;
